module.exports = __webpack_public_path__ + "img/Group155.38b18ec9.svg";